import React from 'react';
import CalendarSyncSettings from '../components/Portal/Calendar/CalendarSyncSettings';

const CalendarSync = () => {
  return (
    <div className="min-h-screen theme-bg-secondary">
      <CalendarSyncSettings />
    </div>
  );
};

export default CalendarSync;
